import * as layout from '../../components/markLayout.module.css';
import React, { useMemo } from 'react';
import Table from '@hero/ui-kit/tables/Table';
import type { BlastSummary } from '../../types';
import getBlastColumns from './getBlastColumns';
import usePagerProps from '../../../../hooks/usePagerProps';
type Props = {
    blasts: BlastSummary[];
    isLoading: boolean;
    pagerProps: ReturnType<typeof usePagerProps>;
};
const BlastsList: React.FC<Props> = ({ blasts, isLoading, pagerProps }) => {
    const columns = useMemo(() => getBlastColumns(), []);
    return (
        <div
            style={{
                overflowX: 'auto'
            }}
            className={layout.tableScroll}
        >
            <Table<BlastSummary>
                columns={columns}
                data={blasts}
                rowKey="blast_id"
                emptyValues="-"
                isLoading={isLoading}
                pagerProps={pagerProps}
            />
        </div>
    );
};
export default BlastsList;
